/*!

=========================================================
* Black Dashboard PRO React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-pro-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// react plugin used to create charts
import { Bar, Line } from "react-chartjs-2";
// react plugin for creating vector maps
import SortingTable from "components/SortingTable/SortingTable.js";
import { isObjEmpty } from '../../utils/utils.js';

// reactstrap components
import {
  Carousel,
  CarouselItem,
  CarouselControl,
  CarouselIndicators,
  CarouselCaption,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  CardText,
  Row,
  Col,
  Spinner
} from "reactstrap";

// core components
import {
  chartExample3,
  chartExample7
} from "variables/charts.js";

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchGetDataIframe } from "../../actions/iframe_actions";

const items = [
	{
		src: '',
		altText: 'Decision Tables',
		caption: 'Decision Tables'
	},
	{
		src: '',
		altText: 'ScoreCard',
		caption: 'Scorecard'
	},
	// {
	// 	src: '',
	// 	altText: 'Model Buckets',
	// 	caption: 'Model Buckets'
	// }
];

class Analytics extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      bigChartData: "data1",
      darkMode: true,
      activeIndex: 0,
      display_conf: {},
      execution_result: {}
    };
    this.next = this.next.bind(this);
		this.previous = this.previous.bind(this);
		this.goToIndex = this.goToIndex.bind(this);
		this.onExiting = this.onExiting.bind(this);
		this.onExited = this.onExited.bind(this);
  }

  componentDidMount() {
    const { fetchGetDataIframe } = this.props;
    const params = new URLSearchParams(this.props.location.search);
    const token = params.get('token');
    // console.log(token)
    fetchGetDataIframe(token);
  }

  componentDidUpdate(prevProps, prevState) {
    // console.log(this.props.iframe, prevProps.iframe)
    if(this.props.iframe && this.props.iframe.display_conf && prevProps.iframe && !prevProps.iframe.display_conf) {
      this.setState({
        display_conf: this.props.iframe.display_conf, 
        execution_result: this.props.iframe.execution_result
      })
    }
  }

  setBgChartData = name => {
    this.setState({
      bigChartData: name
    });
  };

  onExiting() {
		this.animating = false;
	}

	onExited() {
		this.animating = false;
	}

  next() {
		if (this.animating) return;
		const nextIndex = this.state.activeIndex === items.length - 1 ? 0 : this.state.activeIndex + 1;
		this.setState({ activeIndex: nextIndex });
	}

	previous() {
		if (this.animating) return;
		const nextIndex = this.state.activeIndex === 0 ? items.length - 1 : this.state.activeIndex - 1;
		this.setState({ activeIndex: nextIndex });
	}

  goToIndex(newIndex) {
		if (this.animating) return;
		this.setState({ activeIndex: newIndex });
	}

  render() {
    const { activeIndex, execution_result, display_conf } = this.state;
    let info_table = [];
    if(execution_result && execution_result.response && execution_result.response.score_card) {
      info_table = Object.keys(execution_result.response.score_card).length !== 0 && 
      Object.keys(execution_result.response.score_card).map((aux, j) => {
        let dataObject = execution_result.response.score_card[aux];
        let auxObj = {};
        for(let k in execution_result.response.score_card[aux]) {
          if(k === "label" || k === "points" || k === "max_points" || k === "color_map") {
            auxObj[k] = execution_result.response.score_card[aux][k]
          }
        }
        return auxObj
      }).map((val, i) => {
        // console.log(val)
        let aux = val;
        let auxList = {}
        aux.pos = i + 1;
        let cont = 0;
        auxList.data = []
        for(let key in aux) {
          // cont++;
          if(key === "pos") {
            auxList.data[0] = { className: "text-center", text: aux[key] }
          } 
          else if(key === "label") {
            auxList.data[1] = { className: "text-left", text: aux[key] }
          } else if(key === "points") {
            auxList.data[2] = { className: "text-center", text: aux[key], background: val.color_map, stroke: "0.7px #263238", colorText: "black", fontSize: "20px" }
          } else if(key === "max_points") {
            auxList.data[3] = { className: "text-center", text: aux[key] }
          }
        }
        return auxList
      }).sort((a, b) =>
        a.data[3].text > b.data[3].text
          ? -1
          : a.data[3].text < b.data[3].text
          ? 1
          : 0
      );
    }

    const slides = items.map((item) => {
      if(item.altText === 'Decision Tables') {
        let decision_result = execution_result.response ? execution_result.response.rules : [];
        let decision_tree_result = [];
        if(decision_result.length !== 0) {
          decision_tree_result = decision_result.map((val, index) => {
            let obj = {};
            obj.data = [];
            obj.data = [...obj.data, { className: "text-center", text: index + 1 }];
            for(let key in val) {
              if(key === "rule_name") {
                obj.data = [...obj.data, { className: "text-center", text: val[key] }]
              } else if(key === "value") {
                obj.data = [...obj.data, { className: "text-center", text: val[key] }]
              }
            }
            return obj
          })
        }
        // console.log(decision_tree_result)
        // console.log('display_conf: ', display_conf.display_conf)
        let decision_card_list = [];
        let info_value_list = [];
        if(display_conf.display_conf && display_conf.display_conf.decision_screen) {
          for(let key in display_conf.display_conf.decision_screen) {
            let substrDecisionCard = /decision_card/
            let substrInfoValue = /info_value/
            let foundDecisionCard = substrDecisionCard.test(key);
            let foundInfoValue = substrInfoValue.test(key);
            if(foundDecisionCard) {
              decision_card_list = [...decision_card_list, display_conf.display_conf.decision_screen[key]]
            }
            if(foundInfoValue) {
              info_value_list = [...info_value_list, display_conf.display_conf.decision_screen[key]]
            }
          }
        }

        decision_card_list.map((val, i) => {
          let aux = val;
          let decision_card_value = "";
          if(val.field !== "final_decision") {
            decision_card_value = execution_result.response.score[val.field].value;
          } else {
            decision_card_value = execution_result.response[val.field];
          }
          aux.value = decision_card_value
          aux.color = aux.color_map[decision_card_value];
          return aux
        })

        info_value_list.map((val, i) => {
          let aux = val;
          let info_value_value = "";
          info_value_value = execution_result.response.score[val.field].value;
          aux.value = info_value_value
          for(let key in aux.color_map) {
            // console.log(key)
            if(aux.color_map[key][0] <= info_value_value && info_value_value < aux.color_map[key][1]) {
              aux.color = key;
            }
          }
          return aux
        })
        // console.log(decision_card_aux, info_value_aux);

        return (
          <CarouselItem
            onExiting={this.onExiting}
            onExited={this.onExited}
            key={0}
          >
            <Row>
              <Col className="ml-auto mr-auto" md="10" lg="10" sm="10" xs="10">
                <Card className="card-plain" >
                  <CardBody className="card-center">
                    <Col md="12" >
                      {decision_card_list && decision_card_list.length > 0 && decision_card_list.map((val, i) => {
                        return (
                          <Row key={i}>
                            <Col md="12" lg='12'>
                              <Card className="card-stats">
                                <CardHeader tag="h4" >{val.label}</CardHeader>
                                <CardBody className="text-center" style={{ height: "37px", backgroundColor: val.color ? val.color : null, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                  <CardText tag="h5" style={{ color: '#000' }}>
                                    {val.value}
                                  </CardText>
                                </CardBody>
                              </Card>
                            </Col>
                          </Row>
                        )
                      })}
                      <Row>
                        {info_value_list && info_value_list.length > 0 && info_value_list.map((val, j) => {
                          return(
                            <Col
                              xs={
                                info_value_list.length === 3 ? "4" : 
                                info_value_list.length === 4 ? "3" : 
                                info_value_list.length === 2 ? "6" :
                                "12" 
                              } 
                              sm={
                                info_value_list.length === 3 ? "4" : 
                                info_value_list.length === 4 ? "3" : 
                                info_value_list.length === 2 ? "6" :
                                "12" 
                              }
                              md={
                                info_value_list.length === 3 ? "4" : 
                                info_value_list.length === 4 ? "3" : 
                                info_value_list.length === 2 ? "6" :
                                "12" 
                              } 
                              lg={
                                info_value_list.length === 3 ? "4" : 
                                info_value_list.length === 4 ? "3" : 
                                info_value_list.length === 2 ? "6" :
                                "12"
                              }
                              key={j}
                            >
                              <Card className="card-stats">
                                <CardHeader tag="h4">{val.label}</CardHeader>
                                <CardBody className="text-center" style={{ height: "37px", backgroundColor: val.color ? val.color : "#fff", display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                  <CardText tag="h5" style={{ color: '#000' }}>{parseFloat(val.value.toFixed(3))}</CardText>
                                </CardBody>
                              </Card>
                            </Col>
                          )
                        })}
                      </Row>
                      <Row>
                        <Col md="12" lg='12'>
                          <Card>
                            <CardHeader style={{height: "35px"}}>
                              <CardTitle tag="h4">Decision Tree Result Hits</CardTitle>
                            </CardHeader>
                            <CardBody >
                              {decision_tree_result.length > 0 &&
                                <SortingTable
                                  thead={[
                                    { className: "text-center", text: "Num." },
                                    { className: "text-center", text: "Rules" },
                                    { className: "text-center", text: "Decision" }
                                  ]}
                                  tbody={decision_tree_result}
                                />
                              }
                            </CardBody>
                          </Card>
                        </Col>
                      </Row>
                    </Col>
                  </CardBody>
                </Card>
              </Col>
            </Row>
            <CarouselCaption captionText={item.caption}/>
          </CarouselItem>
        )
      } else if(item.altText === 'ScoreCard') {
        return (
          <CarouselItem
            onExiting={this.onExiting}
            onExited={this.onExited}
            key={1}
          >
            <Row>
              <Col className="ml-auto mr-auto" md="10" lg="10" xl="10">
                <Card className="card-plain" >
                  <CardBody className="card-center">
                    <Card>
                      <CardHeader style={{ maxHeight: '35px' }}>
                        <CardTitle tag="h4">ScoreCard</CardTitle>
                      </CardHeader>
                      <CardBody >
                        {info_table && info_table.length > 0 &&
                          <SortingTable
                            thead={[
                              { className: "text-center", text: "Num." },
                              { className: "text-center", text: "Variable" },
                              { className: "text-center", text: "Score" },
                              { className: "text-center", text: "Max Points" }
                            ]}
                            tbody={info_table}
                          />
                        }
                      </CardBody>
                    </Card>
                  </CardBody>
                </Card>
              </Col>
            </Row>
            <CarouselCaption captionText={item.caption}/>
          </CarouselItem>
        )
      } else {
        let bucketList = []
        if(display_conf.score_card && execution_result.response) {
          bucketList = display_conf.score_card.rules.map((val, i) => {
            let aux = val;
            return {
              buckets: aux.buckets,
              field_name: aux.field_name,
              label: aux.label
            }
          }).map((value, i) => {
            let aux2 = value;
            let arrayValues = [];
            let filter = execution_result.response.score_card[value.field_name];
            aux2.points = filter.points;
            aux2.color = filter.color_map;
            aux2.bucket_value = filter.bucket_label;
            for(let j = 0; j < aux2.buckets.length; j++) {
              if(aux2.buckets[j].bucket_label === aux2.bucket_value) {
                arrayValues = [...arrayValues, 0.5]
              } else {
                arrayValues = [...arrayValues, NaN]
              }
            }
            aux2.categories = aux2.buckets.map(a => a.bucket_label);
            aux2.values = arrayValues;
            // console.log(arrayValues)
            return aux2;
          })
        }
        //-------------------------------------------------------------
        // console.log(bucketList)
        return (
          <CarouselItem
            onExiting={this.onExiting}
            onExited={this.onExited}
            key={2}
          >
            <Row>
              <Col className="ml-auto mr-auto" md="10" lg="10" xl="10">
                <Card className="card-plain" >
                  <CardBody className="card-center">
                    <Card className="card-chart">
                      <CardHeader style={{height: "55px"}}>
                        <CardTitle tag="h4">Model Buckets</CardTitle>
                      </CardHeader>
                      <CardBody>
                        {bucketList && bucketList.length !== 0 && bucketList.map((val, index) => {
                          let data = canvas => {
                            let ctx = canvas.getContext("2d");
                            var gradientStroke = ctx.createLinearGradient(0, 230, 0, 50);

                            gradientStroke.addColorStop(1, "rgba(0,135,191,0.2)");
                            gradientStroke.addColorStop(0.8, "rgba(0,135,191,0.1)");
                            gradientStroke.addColorStop(0, "rgba(0,84,119,0.1)"); //blue colors
                            return {
                              labels: val.categories,
                              datasets: [
                                {
                                  // label: "Categories",
                                  fill: true,
                                  backgroundColor: val.color,
                                  hoverBackgroundColor: val.color,
                                  borderColor: val.color,
                                  borderWidth: 2,
                                  borderRadius: 100,
                                  borderSkipped: false,
                                  // borderDash: [],
                                  borderDashOffset: 0.0,
                                  barPercentage: 1.0,
                                  categoryPercentage: 1.0,
                                  data: val.values,
                                  pointRadius: 10,
                                  pointHoverRadius: 10
                                }
                              ]
                            }
                          }

                          let options = {
                            maintainAspectRatio: false,
                            responsive: true,
                            legend: {
                              display: false
                            },
                            tooltips: {
                              backgroundColor: "#f5f5f5",
                              borderWidth: 2,
                              titleFontColor: "#333",
                              titleFontSize: 10,
                              titleAlign: "center",
                              bodyFontColor: "#666",
                              bodyFontSize: 10,
                              bodySpacing: 4,
                              bodyAlign: "center",
                              xPadding: 65,
                              mode: "nearest",
                              intersect: 0,
                              position: "nearest",
                              callbacks: {
                                label: function(tooltipItem, data) {
                                  return "Points: " + val.points;
                                }
                              },
                              custom: function(tooltipModel) {
                                // console.log(tooltipModel)
                                tooltipModel.height = 35
                                tooltipModel.width = 190
                                tooltipModel.y = 0
                                tooltipModel.x = tooltipModel.x <= 600 ? tooltipModel.x : 650
                                tooltipModel.xAlign = "center"
                                tooltipModel.yAlign = "bottom"
                                tooltipModel.title = [val.label]
                              },
                            },
                            responsive: true,
                            scales: {
                              // display: false,
                              yAxes: [
                                {
                                  display: false,
                                  gridLines: {
                                    offsetGridLines: false,
                                    // drawBorder: false,
                                    // color: "rgba(225,78,202,0.1)",
                                    // zeroLineColor: "transparent"
                                  },
                                  ticks: {
                                    suggestedMin: 0,
                                    suggestedMax: 1,
                                    padding: 0,
                                    fontColor: "#9e9e9e"
                                  }
                                }
                              ],
                              xAxes: [
                                {
                                  stacked: true,
                                  gridLines: {
                                    offsetGridLines: false,
                                    // drawBorder: false,
                                    // color: "rgba(225,78,202,0.1)",
                                    // zeroLineColor: "transparent"
                                  },
                                  ticks: {
                                    padding: -5,
                                    fontColor: "#9e9e9e"
                                  }
                                }
                              ],
                              x: {
                                grid: {
                                  offset: true
                                }
                              },
                              y: {
                                grid: {
                                  offset: true
                                }
                              }
                            }
                          }
                          return (   
                            <div style={{display: 'flex'}} key={index}>
                              <CardText className='text-center' style={{width: '27px', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>{index + 1}</CardText>
                              <div className="chart-area-analytics" key={index}>
                                <Line
                                  data={data}
                                  options={options}
                                />
                              </div>
                            </div>
                          )
                        })}
                        {/* <div className="chart-area-analytics" key={1}>
                          <Bar
                            data={chartExample3.data}
                            options={chartExample3.options}
                          />
                        </div> */}
                      </CardBody>
                    </Card>
                  </CardBody>
                </Card>
              </Col>
            </Row>
            <CarouselCaption captionText={item.caption}/>
          </CarouselItem>
        )
      }
		});

    return (
      <>
      {isObjEmpty(execution_result) || isObjEmpty(display_conf) ?
        <div 
          className="content" 
          style={{
            maxWidth: '99vw',
            minHeight: '70vh',
            marginTop: "30px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }}>
          <Spinner style={{ width: '6rem', height: '6rem' }}/>
        </div> :
        <div className="content" style={{maxWidth: '99vw', marginTop: "30px"}}>
          <Row>
            <Col xl="12" lg='12' md='12' >
              <Carousel
                activeIndex={activeIndex}
                next={this.next}
                previous={this.previous}
                interval={false}
              >
                <CarouselIndicators 
                  items={items} 
                  activeIndex={activeIndex} 
                  onClickHandler={this.goToIndex}
                />
                {slides}
                <CarouselControl direction='prev' directionText='Previous' onClickHandler={this.previous} />
                <CarouselControl direction='next' directionText='Next' onClickHandler={this.next} />
              </Carousel>
            </Col>
          </Row>
        </div> 
      }
      </>
    );
  }
}

function mapStateToProps({iframe}){
  return{
    iframe
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators(
      { fetchGetDataIframe }, dispatch
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(Analytics);

/* <CardGroup>
                            <Card style={{border: "1px solid", backgroundColor: '#2083f7'}} className="text-center">
                              <CardBody>
                                <CardTitle tag="h4" style={{color: "#fff"}}>Total Calls.</CardTitle>
                                <CardText style={{color: "#fff"}}>2.3K</CardText>
                              </CardBody>
                            </Card >
                            <Card style={{border: "1px solid", backgroundColor: '#2083f7'}} className="text-center">
                              <CardBody>
                                <CardTitle tag="h4" style={{color: "#fff"}}>Calls Last Month</CardTitle>
                                <CardText style={{color: "#fff"}}>500</CardText>
                              </CardBody>
                            </Card>
                            <Card style={{border: "1px solid", backgroundColor: '#2083f7'}} className="text-center">
                              <CardBody>
                                <CardTitle tag="h4" style={{color: "#fff"}}>Error Calls</CardTitle>                              
                                <CardText style={{color: "#fff"}}>2.3K</CardText>
                              </CardBody>
                            </Card>
                          </CardGroup> */

                          /* <Col sm="6">
                      <ButtonGroup
                        className="btn-group-toggle float-right"
                        data-toggle="buttons"
                      >
                        <Button
                          color="info"
                          id="0"
                          size="sm"
                          tag="label"
                          className={classNames("btn-simple", {
                            active: this.state.bigChartData === "data1"
                          })}
                          onClick={() => this.setBgChartData("data1")}
                        >
                          <input defaultChecked name="options" type="radio" />
                          <span className="d-none d-sm-block d-md-block d-lg-block d-xl-block">
                            Accounts
                          </span>
                          <span className="d-block d-sm-none">
                            <i className="tim-icons icon-single-02" />
                          </span>
                        </Button>
                        <Button
                          color="info"
                          id="1"
                          size="sm"
                          tag="label"
                          className={classNames("btn-simple", {
                            active: this.state.bigChartData === "data2"
                          })}
                          onClick={() => this.setBgChartData("data2")}
                        >
                          <input name="options" type="radio" />
                          <span className="d-none d-sm-block d-md-block d-lg-block d-xl-block">
                            Purchases
                          </span>
                          <span className="d-block d-sm-none">
                            <i className="tim-icons icon-gift-2" />
                          </span>
                        </Button>
                        <Button
                          color="info"
                          id="2"
                          size="sm"
                          tag="label"
                          className={classNames("btn-simple", {
                            active: this.state.bigChartData === "data3"
                          })}
                          onClick={() => this.setBgChartData("data3")}
                        >
                          <input name="options" type="radio" />
                          <span className="d-none d-sm-block d-md-block d-lg-block d-xl-block">
                            Sessions
                          </span>
                          <span className="d-block d-sm-none">
                            <i className="tim-icons icon-tap-02" />
                          </span>
                        </Button>
                      </ButtonGroup>
                    </Col> */

                    /* <Row>
            <Col md="6" >
              
                <Row>
                  <Col md="12" lg='12'>
                    <Card className="card-stats" style={{marginBottom: '10px'}}>
                      <CardHeader tag="h4" >Final Decision</CardHeader>
                      <CardBody className="text-center" style={{ height: "37px", backgroundColor: '#F3EB4D', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                        <CardText tag="h5" style={{ color: '#000' }}>
                          Review
                        </CardText>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
                <Row>
                  <Col md="12" lg='12'>
                    <Card className="card-stats" style={{marginBottom: '10px'}}>
                      <CardHeader tag="h4">Preliminary Decision</CardHeader>
                      <CardBody className="text-center" style={{ height: "37px", backgroundColor: '#99D337', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <CardText tag="h5" style={{ color: '#000' }}>Recommended Approve</CardText>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
                <Row>
                  <Col md="12" lg='12'>
                    <Card className="card-stats" style={{marginBottom: '10px'}}>
                      <CardHeader tag="h4">Request Kin Analytics Score</CardHeader>
                      <CardBody className="text-center" style={{ height: "37px", backgroundColor: '#F3EB4D', justifyContent: 'center', alignItems: 'center', paddingTop: '1px'}}>
                        C
                        <br/>
                        <div className="category"style={{ color: '#000' }}>2.05%</div>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
            </Col>
            <Col md="6">
              <Card >
                <CardHeader>
                  <CardTitle tag="h4">Decision Tree Result Hits</CardTitle>
                </CardHeader>
                <CardBody style={{maxHeight: '198px'}}>
                  <SortingTable
                    thead={[
                      { className: "text-center", text: "Num." },
                      { className: "text-center", text: "Rules" },
                      { className: "text-center", text: "Decision" }
                    ]}
                    tbody={decision_data}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row> */

          /* <Row>
            <Col xl="6">
              <Card >
                <CardHeader style={{ maxHeight: '30px' }}>
                  <CardTitle tag="h4">ScoreCard</CardTitle>
                </CardHeader>
                <CardBody style={{ maxHeight: '520px' }}>
                  <SortingTable
                    thead={[
                      { className: "text-center", text: "Num." },
                      { className: "text-center", text: "Variable" },
                      { className: "text-center", text: "Score" },
                      { className: "text-center", text: "Max Points" }
                    ]}
                    tbody={info_data}
                  />
                </CardBody>
              </Card>
            </Col>
            <Col xl="6">
              <Card className="card-chart">
                <CardHeader>
                  <CardTitle tag="h4">Model Buckets</CardTitle>
                </CardHeader>
                <CardBody>
                  {data_chart && data_chart.length && data_chart.map((val, index) => {
                    let data = {
                      labels: val.categories,
                      datasets: [
                        {
                          label: "Categories",
                          fill: true,
                          backgroundColor: val.color,
                          // hoverBackgroundColor: "rgba(119,52,169,0)",
                          borderColor: val.color,
                          borderWidth: 2,
                          borderDash: [],
                          borderDashOffset: 0.0,
                          data: val.values,
                          barPercentage: 1.0,
                          categoryPercentage: 1.0
                        }
                      ]
                    }
                    return (   
                      <div style={{display: 'flex'}} key={index}>
                        <CardText className='text-center' style={{width: '27px', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>{index + 1}</CardText>
                        <div className="chart-area-analytics" key={index}>
                          <Bar
                            data={data}
                            options={chartExample3.options}
                          />
                        </div>
                      </div>
                    )
                  })}
                </CardBody>
              </Card>
            </Col>
          </Row> */